import React, { useEffect, useState } from 'react'
import './testimonials.css'
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'
import { createClient } from "@supabase/supabase-js";

import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const supabase = createClient("https://rmbpolfkfrjxzratkois.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtYnBvbGZrZnJqeHpyYXRrb2lzIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODA4MzEyNjUsImV4cCI6MTk5NjQwNzI2NX0.Kk_92vWnFOYJPA-uZ-ZZGC2LhTLB4_2f_t8Q0juzBGI");

const Testimonials = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getCountries();
  }, []);

  async function getCountries() {
    const { data } = await supabase.from("reviews").select('*');
    setCountries(data);
  }

  const phrases = ["{Reviews}", "{Reviews} "]
  return (
    <section id="reviews">
      <h5>Review form clients</h5>
      {/* <h2>Testimonails</h2> */}
      <h2><TextScrambler phrases={phrases} speed={5} pauseTime={1000}/></h2>

      <Swiper className="container testimonails__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {
          countries.map((country, index) => {
            return(
            <SwiperSlide key={index} className='testimonail'>
              <div className="client__avatar">
                <img src={country.client_avatar} alt='clientavatar' />
              </div>
              <h5 className='client__name'>{country.client_name}</h5>
              <small className='client__review'>{country.client_review}</small>
            </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials
